module.exports = ['$utils', '$q', 'Message', 'User', 'mailService', 'Promise', '$translate',
  function ($utils, $q, Message, User, mailService, Promise, $translate) {
    function MailDealingFolder(dealingEmail, start, limit, order, desc, returnTotal, summaryWindowSize) {
      this.uid = User.getCurrentUser().config.email // 当前登录用户的邮箱地址
      this.dealingEmail = dealingEmail // 往来邮件联系人邮箱地址
      this.start = start || 0 // 分页参数
      this.limit = limit || 20 //  分页参数
      this.order = order || 'date' // 排序方式
      this.desc = desc || true // 排序方式
      this.returnTotal = returnTotal || true // 是否返回总数
      this.summaryWindowSize = summaryWindowSize || 20 // 概要窗口范围
      this.ids = []
      this.messages = [] // 信件列表
      this.total = 0 // 信件总数，非this.messages的长度
    }
    /**
       * 获取与指定联系人的往来邮件
       * @param params 参数对象，包含contactId, start, limit, order
       * @returns 返回与该联系人的往来邮件
       */
    MailDealingFolder.prototype.getDealingMails = function (params) {
      const deferred = $q.defer()
      const self = this
      const temp = {
        fid: 0,
        order: self.order,
        desc: true,
        filter: {
          flags: { draft: false, rcptFailed: false },
          chatWithAddress: self.dealingEmail
        },
      }
      MailDealingFolder.prototype.searchMessages(temp).then(function (data) {
        self.ids = data.var
        self.total = data.var.length
      }, function () {
      }).finally(function () {
        const start = params && params.hasOwnProperty('start') ? params.start : self.start
        const limit = params && params.hasOwnProperty('limit') ? params.limit : self.limit
        const temp = {
          desc: self.desc,
          summaryWindowSize: self.summaryWindowSize,
          ids: self.ids.slice(start, start + limit)
        }
        MailDealingFolder.prototype.getMessageInfos(temp).then(function (data) {
          MailDealingFolder.prototype.formatMessages(data.var)
          const messages = Message.buildMessages(data.var)
          self.messages = []
          self.messages = self.messages.concat(messages)
          self.start = self.messages.length
          deferred.resolve(messages)
        }, function () {
        })
      })
      return deferred.promise
    }
    /**
       * 加载更多往来邮件
       * @returns 返回邮件数组
       */
    MailDealingFolder.prototype.loadMoreDealingMails = function () {
      const deferred = $q.defer()
      const self = this
      const temp = {
        desc: self.desc,
        summaryWindowSize: self.summaryWindowSize,
        ids: self.ids.slice(self.start, self.start + self.limit)
      }
      MailDealingFolder.prototype.getMessageInfos(temp).then(function (data) {
        MailDealingFolder.prototype.formatMessages(data.var)
        const messages = Message.buildMessages(data.var)
        self.messages = self.messages.concat(messages)
        self.start = self.messages.length
        deferred.resolve(messages)
      }, function () {
        deferred.reject([])
      })
      return deferred.promise
    }
    /**
       * 列举邮件
       * @param params 参数对象，具体参考wmsvr的接口文档
       * @returns 返回邮件数组
       */
    MailDealingFolder.prototype.listMessages = function (params) {
      const deferred = $q.defer()
      if (!params) {
        deferred.reject([])
      } else {
        Promise.wmCall('mbox:listMessages', params).then(function (data) {
          if (data.code === 'S_OK') {
            MailDealingFolder.prototype.formatMessages(data.var)
            deferred.resolve(data)
          }
        }, function (error) {
          console.log(error)
          deferred.reject([])
        })
      }
      return deferred.promise
    }
    /**
      * 搜索邮件
      * @param params 参数对象，具体参考wmsvr的接口文档
      * @returns 返回邮件id数组
      */
    MailDealingFolder.prototype.searchMessages = function (params) {
      const deferred = $q.defer()
      if (!params) {
        deferred.reject([])
      } else {
        Promise.wmCall('mbox:searchMessages', params).then(function (data) {
          if (data.code === 'S_OK') {
            deferred.resolve(data)
          }
        }, function (error) {
          console.log(error)
          deferred.reject([])
        })
      }
      return deferred.promise
    }
    /**
      * 获取邮件详情
      * @param params 参数对象，具体参考wmsvr的接口文档
      * @returns 返回邮件详情数组
      */
    MailDealingFolder.prototype.getMessageInfos = function (params) {
      const deferred = $q.defer()
      if (!params) {
        deferred.reject([])
      } else {
        Promise.wmCall('mbox:getMessageInfos', params).then(function (data) {
          if (data.code === 'S_OK') {
            deferred.resolve(data)
          }
        }, function (error) {
          console.log(error)
          deferred.reject([])
        })
      }
      return deferred.promise
    }
    /**
       * 信件格式化
       * @messages 信件数组
       * @returns 返回邮件数组
       */
    MailDealingFolder.prototype.formatMessages = function (messages) {
      if (!messages) {
        return []
      } else {
        messages.forEach(function (message) {
          message.name = $utils.$email.parseTrueName(message.from)
          message.email = $utils.$email.parse(message.from).addr
          message.summary = message.summary || $translate.instant('MAIL.NO_SUMMARY')
        })
      }
    }
    /**
      * 获取往来邮件列表
      * @returns 邮件列表引用
      */
    MailDealingFolder.prototype.getMessages = function () {
      return this.messages
    }

    return MailDealingFolder
  }]



// WEBPACK FOOTER //
// ./src/js/mail/MailDealingFolder.js